export const enum FormTypes {
    HomeSchoolRegistrationInformation = 1,
    SchoolTransferWithdrawal = 2,
    EnrollmentVerificationInformation = 3,
    OSAwardEndorsement = 4,
    AwardAcceptance = 5,
    LEARelease = 6,
    ESAAwardEndorsement = 7,
    IncomeVerification = 8,
    VerificationOfNonFiling = 9,
    GuardianChange = 10,
    HouseholdTransferWithdrawal = 11
}